import * as React from 'react';
import { isMobile } from 'src/utils/responsiveHelpers';
import Checkbox from 'src/components/common/Checkbox';
import './CreditCard.scss';
import env from 'src/shared/env';

interface ICreditCardProps {
  show: boolean;
  onSuccess: () => void;
  onCancel: () => void;
  creditCardUrl: string;
  saveCard?: boolean;
  onSaveCard?: (save: boolean) => void;
}

interface ICreditCardState {
  isMobile: boolean;
}

class CreditCard extends React.Component<ICreditCardProps, ICreditCardState> {
  constructor(props: any) {
    super(props);

    this.state = {
      isMobile: isMobile()
    };
  }

  public componentDidMount() {
    const script = document.createElement('script');

    script.src = `${env.REACT_APP_BASE_WORDPRESS_URL}wp-content/rpfiles/pi_OHPResponseScript.js`;
    script.async = true;

    document.body.appendChild(script);
  }

  public componentWillMount() {
    window.addEventListener('resize', this.handleWindowSizeChange);
  }

  public componentWillUnmount() {
    window.removeEventListener('resize', this.handleWindowSizeChange);
  }

  public handleWindowSizeChange = () => {
    const isMob = isMobile();
    if (isMob !== this.state.isMobile) {
      this.setState({ isMobile: isMob });
    }
  };

  public render() {
    return (
      this.props.show && (
        <div className="rp-credit-card">
          <div id="info-message" />
          <div id="error-message" />
          <button id="success-trigger" onClick={this.props.onSuccess} />
          <button id="cancel-trigger" onClick={this.props.onCancel} />
          <iframe
            className="rp-credit-card-iframe"
            src={this.props.creditCardUrl}
          />
          <div className="rp-credit-card--save-card">
            <Checkbox
              name={'Do you want to save this card?'}
              value={'saveCard'}
              checked={this.props.saveCard}
              onChange={this.props.onSaveCard}
            />
          </div>
        </div>
      )
    );
  }
}

export default CreditCard;
